// extracted by mini-css-extract-plugin
export default {"footerDiv":"footer_footerDiv__4vAux","new":"footer_new__8rYqK"};